module.exports = require("angular");